import { Reveal } from "./Reveal";

const TEAM = [
  {
    name: "Anthony Murray",
    role: "Founder & CEO",
    img: "/team/anthony-murray.jpg?v=3",
    offset: false,
  },
  {
    name: "Nichols Mullen",
    role: "Chief Operating Officer",
    img: "/team/nichols-mullen.jpg?v=1",
    offset: true,
  },
  {
    name: "Joel James",
    role: "Head of Marketing",
    img: "/team/joel-james.jpg?v=1",
    offset: false,
  },
];

export const Team = () => (
  <section id="team" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 lg:py-40" data-testid="team-section">
    <Reveal className="max-w-3xl mb-16 md:mb-24">
      <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-quantum-gold mb-6">Our team</p>
      <h2 className="font-serif-q text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-light text-quantum-text">
        The people behind Qauntum.
      </h2>
    </Reveal>

    <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
      {TEAM.map((m, i) => (
        <Reveal
          key={m.name}
          delay={i * 0.1}
          className={`group ${m.offset ? "lg:mt-16" : ""}`}
        >
          <div
            data-testid={`team-member-${i}`}
            className="relative overflow-hidden border border-white/10 bg-quantum-bg2 aspect-[4/5]"
          >
            <img
              src={m.img}
              alt={m.name}
              loading="lazy"
              className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-quantum-bg/80 via-transparent to-transparent" />
          </div>
          <div className="mt-5">
            <h3 className="font-serif-q text-xl md:text-2xl text-quantum-text leading-tight">{m.name}</h3>
            <p className="text-xs md:text-sm uppercase tracking-[0.15em] text-quantum-gold mt-1">{m.role}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
